import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import { privateFetcher } from 'services';
import { getIsDemoExperience } from 'services/globalConfig.services';
import { EvaluateShipmentPayloadDTO } from './evaluateShipment.fetcher.dto';

/**
 * Must be eligible, and must be snake_case. The response mapper yields `false`
 * silently for a camelCase body, and a negative answer renders the
 * "not eligible" explainer in place of the return button — removing the very
 * thing the demo is meant to show.
 *
 * The call fires from a mount effect, before any click, so disabling or hiding
 * the button does not prevent it; only this branch does.
 */
const DEMO_ELIGIBILITY = {
  data: {
    is_shipment_eligible_for_return: true,
    non_eligible_line_items: [],
  },
};

export const postEvaluateShipment = async (
  organizationId: number,
  params: EvaluateShipmentPayloadDTO,
): Promise<{ data: unknown }> => {
  if (getIsDemoExperience()) {
    return DEMO_ELIGIBILITY;
  }

  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/shipments/${organizationId}/eligibility/`;
    const { data } = await privateFetcher.get(url, {
      params,
    });
    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response.data?.message, error);
    }

    throw error;
  }
};
